import { createReducer, on } from '@ngrx/store';
import { DatosGenerales } from '../../Models/datosGenerales';
import { loadCotizacion, setData, updateResponse } from './data.actions';

// If you don't have access to modify DatosGenerales, cast to 'any' in the reducer

export interface DataState {
  data: DatosGenerales | null;
  error: string;
}

export const initialState: DataState = {
  data: {
    Lead: {
      assessor_code: 0,
      plate: '',
      confirm_plate: '',
      owner_borndate: '',
      circulation_zone_id: '',
      use_type: '',
      accept_tos: false,
      name: '',
      mobile_phone: '',
    },
    estadoDiscador: 'No aplica',
    LeadResponse: {
      additionalInfo: {
        isPrenda: '',
        prendario: '',
      },
      error: 0,
      errorCode: '',
      message: '',
      data: {
        Id: '',
        lead: {
          accept_tos: false,
          mobile_phone: '',
          owner_borndate: '',
        },
        vehicle: {
          Prenda: '',
          brand: '',
          circulation_zone_id: '',
          cylinder: '',
          model: '',
          owner: {
            document: {
              number: '',
              type: '',
            },
            firstnames: '',
            lastnames: '',
          },
          plate: '',
          use_type: '',
        },
      },
    },
  },
  error: '',
};
export const dataReducer = createReducer(
  initialState,
  on(loadCotizacion, (state, { data }) => ({ ...state, data })),
  on(updateResponse, (state, { leadR }) => ({
    ...state,
    data: state.data ? { ...state.data, LeadResponse: leadR } : state.data,
  })),
  on(setData, (state, { key, value, merge }) => ({
    ...state,
    data: state.data
      ? {
        ...state.data,
        [key]: merge ? deepMerge((state.data as any)[key] || {}, value) : value,
      }
      : state.data,
  })),
);

function deepMerge(target: any, source: any): any {
  // Si alguno es null o undefined, retornar source
  if (target == null || source == null) {
    return source || target;
  }

  // Si alguno no es un objeto, retornar source
  if (typeof target !== 'object' || typeof source !== 'object') {
    return source;
  }

  // Si target está vacío, retornar source
  if (Object.keys(target).length === 0) {
    return source;
  }

  const targetCopy = { ...target }; // Create a shallow copy of the target object
  return Object.keys(source).reduce((acc, key) => {
    acc[key] = key in targetCopy ? deepMerge(targetCopy[key], source[key]) : source[key];
    return acc;
  }, targetCopy);
}
